/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React example components
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import PageLayout from "examples/LayoutContainers/PageLayout";

// Authentication pages components
import Footer from "layouts/authentication/components/Footer";
import Header from "layouts/authentication/components/Header";

// Updated background image
import bgImage from "assets/images/homepage.png"; // Ensure this file is placed in your project structure
import logoTSS from "assets/images/TSSLogo.png";

function BasicLayout({ image = bgImage, children }) {
  return (
    <PageLayout sx={{ height: "100vh", overflow: "hidden" }}>
      {/* <Header title="" /> */}

      {/* Background Section */}
      <MDBox
        position="absolute"
        width="100%"
        minHeight="100vh"
        sx={{
          backgroundImage: image ? `url(${image})` : "none",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          zIndex: -1, // Keeps the background behind everything
        }}
      />

      {/* Page Content */}
      <MDBox px={1} width="100%" height="100vh" mx="auto">
        <Grid container spacing={1} justifyContent="center" alignItems="center" height="100%">
          <Grid item xs={11} sm={9} md={5} lg={4} xl={3}>
            {children}
          </Grid>
        </Grid>
      </MDBox>

      <Footer light />
    </PageLayout>
  );
}

// Typechecking props for BasicLayout
BasicLayout.propTypes = {
  image: PropTypes.string, // Image URL as a string (optional)
  children: PropTypes.node.isRequired, // Required children elements
};

export default BasicLayout;
